import { render, staticRenderFns } from "./roadBook.vue?vue&type=template&id=20c5a3cd&"
import script from "./roadBook.vue?vue&type=script&lang=js&"
export * from "./roadBook.vue?vue&type=script&lang=js&"
import style0 from "./roadBook.vue?vue&type=style&index=0&id=20c5a3cd&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports